export default function setViewportMetaTag() {
    const viewport = document.querySelector('meta[name=viewport]');
    viewport.setAttribute('content', viewport.content + ', height=' + window.innerHeight);
}
